var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.5,75.5H45.5v-30h165ZM195.5,241H60.5V90.5h135Zm-90-226h45V30.5h-45ZM90.5,0V30.5h-60v60h15V256h165V90.5h15v-60h-60V0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "",
    x: 85.5,
    y: 115.64,
    width: 15,
    height: 100.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "",
    x: 155.5,
    y: 115.57,
    width: 15,
    height: 100.36
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "",
    x: 120.5,
    y: 115.64,
    width: 15,
    height: 100.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.5d973136.svg";
export { ForwardRef as ReactComponent };